export default __webpack_public_path__ + "static/media/people-fill-gray5-48.7d550368.svg";